document.addEventListener("DOMContentLoaded", function(){

    var swipersocial = new Swiper(".socialmedia__v2--linksinner", {
        slidesPerView: 1.2,
        spaceBetween: 16,
        centeredSlides: false,
        loop: true,
      
        navigation: {
          nextEl: ".swiper-button-next.testimonials",
          prevEl: ".swiper-button-prev.testimonials",
        },
        breakpoints: {
            640: {
              slidesPerView: 1.2,
              spaceBetween: 16,
            },
            768: {
              slidesPerView: 2.5,
              spaceBetween: 16,
              centeredSlides: false,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 16,
              centeredSlides: false,
            },
          },
      });
      });



var playButton=document.querySelectorAll(".play__button");
var videoMain=document.querySelectorAll(".social__content--video video");


playButton.forEach(function(ele){



ele.addEventListener("click", function(){
  var parentDiv = ele.closest(".socialpost--main");
  var innerVideo=parentDiv.querySelector(".social__content--video video");
  var videoPoster=parentDiv.querySelector('.image__poster')
  innerVideo.play();
  innerVideo.controls = true;
  videoPoster.style.display="none";
})
})

videoMain.forEach(function(ele){
  ele.addEventListener("pause",function(){
    var videoParent = ele.closest(".socialpost--main");
    var videoControls=videoParent.querySelector(".social__content--video");
    var videoControlsm=videoParent.querySelector(".social__content--video video");
    var videoPoster=videoControls.querySelector('.image__poster');
    videoControlsm.controls = false;
    videoPoster.style.display="block";
    
  })
})

